module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.cf031a4e.png";